exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titleandtool_style_listitem__GUhhC {\n  display: inline-flex;\n  width: 100%;\n  align-items: center;\n  justify-content: flex-start; }\n\n.titleandtool_style_popup_content__3n-nz {\n  padding: 24px; }\n\n.titleandtool_style_detail_function_button_area__1qwKY {\n  width: 100%;\n  margin-top: 12px;\n  display: inline-flex;\n  justify-content: center; }\n", ""]);

// exports
exports.locals = {
	"listitem": "titleandtool_style_listitem__GUhhC",
	"popup_content": "titleandtool_style_popup_content__3n-nz",
	"detail_function_button_area": "titleandtool_style_detail_function_button_area__1qwKY"
};